<template>
  <highcharts ref="chart" :options="chartOptions" style="height:250px"></highcharts>

</template>

<script>


import {Chart as highcharts} from "highcharts-vue";

export default {
  name: "LevelCalibrationGraph",
  components: { highcharts },
  props: {
    loading: {type: Boolean, default: false},
    result: {type: Array, required: true},
  },

  watch: {
    result: function() {

      let data0 = [];
      let data1 = [];
      this.result.forEach((item, key) => {
        data0.push({x: key+1, y: item.fact_distribution, name:item.name});
        data1.push({x: key+1, y: item.normal_distribution, name:item.name});
      });

      this.$refs.chart.chart.series[0].setData(
        data0,
        false
      );

      this.$refs.chart.chart.series[1].setData(
        data1,
        true
      );
    }
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: 'spline'
        },
        credits: {enabled: false},
        title: false,
        plotOptions: {
          series: {
            lineWidth: 4,
          }
        },

        yAxis: {
          title: false,
          max: 100,
          labels: {
            format: '{value}%'
          }
        },
        xAxis: {
          type: 'category',
        },

        series: [
          {
            name: 'Фактическое распределение',
            color:'#6c9bff',
            dataLabels: {
              enabled: true,
              format: '{y}%',
              style: { fontSize: '20px'},
            },
          },
          {
            name: 'Нормальное распределение',
            color: '#ffa44a',
            dataLabels: {
              enabled: true,
              format: '{y}%',
              style: { fontSize: '20px'},
            },
          },
        ],
      }
    }
  },

  methods: {},
}
</script>

<style lang="scss">

</style>